import { api } from './http'
import { makeCrud } from './crud'

// Instancias CRUD genéricas de cada catálogo. Las listas usan view=BaseList + search JSON.
// Los toPayload de cada página trimean los anidados a {id}. Los contratos de ALTA/EDICIÓN
// se validan en vivo por ABM (ver páginas).
export const productosCrud = makeCrud('productos', { searchPaths: ['nombre', 'codigo'] })
export const serviciosCrud = makeCrud('servicios', { searchPaths: ['descripcion'] })
// /almacenes BaseList NO trae `codigo` (es server-generated); typeahead solo por descripcion.
export const depositosCrud = makeCrud('almacenes', { searchPaths: ['descripcion'] })
export const cotizacionesCrud = makeCrud('cotizacionmonedas', { searchPaths: [] })
export const formasPagoCrud = makeCrud('formapago', { searchPaths: ['descripcion'] })

// Monedas = Tipos del sistema (GET /tipos/tipo/monedas). Solo lectura.
export const monedasApi = {
  listar: () => api.get('/tipos/tipo/monedas').then((r) => r.data),
  buscar: () => api.get('/tipos/tipo/monedas').then((r) => r.data),
}

// Catálogo de tipos de impuesto (IVA) para selects de productos/servicios.
// VIVO (2026-06-25): GET /tipoimpuestos?view=BaseList -> [EXENTO, IVA 10%, IVA 5%] (3 items).
// Es @NotNull en el alta de Servicios (POST /servicios sin tipoImpuesto => 400).
export const getTiposImpuesto = () => api.get('/tipoimpuestos', { params: { view: 'BaseList' } }).then((r) => r.data)

// Clases de forma de pago (catálogo de tipos). @NotNull en el alta de Formas de pago
// (POST /formapago sin clase => 400 [PROPERTY][clase][must not be null]).
// VIVO (2026-06-25): GET /tipos/tipo/clase_forma_pago -> Efectivo, Cheque, Tarjeta, Debito,
// Retención, Referencias, Cuenta Contable, Transferencia Bancaria.
export const getClasesFormaPago = () => api.get('/tipos/tipo/clase_forma_pago').then((r) => r.data)
